import Box from '@/components/UI/Box';
import Button from '@/components/UI/Button';
import Text from '@/components/UI/Text';
import Icon from '../Unistyles/Icon';

export default function PaginatorIndeterminate({
  previousPage,
  nextPage,
  limit = 0,
  offset = 0,
  total = 0,
}: {
  previousPage: () => void;
  nextPage: () => void;
  limit: number;
  offset: number;
  total?: number;
}) {
  const hasNextPage = total > limit - 1;
  const currentPage = offset / (limit - 1) + 1;

  return hasNextPage || currentPage !== 1 ? (
    <Box
      direction="horizontal"
      space="md"
      align="center"
      alignSelf="center"
      p="xl"
    >
      <Button
        iconOnly
        size="sm"
        shape="circle"
        variant="primary"
        appearance="outline"
        onPress={previousPage}
        disabled={currentPage <= 1}
      >
        <Icon name="chevron-back-outline" />
      </Button>
      <Text>Page {currentPage}</Text>
      <Button
        iconOnly
        size="sm"
        shape="circle"
        variant="primary"
        appearance="outline"
        onPress={nextPage}
        disabled={!hasNextPage}
      >
        <Icon name="chevron-forward-outline" />
      </Button>
    </Box>
  ) : null;
}
